<template>
  <Admin style="background: #f2f2f2">
    <v-main>
      <v-container fluid>
        <!-- Snackbar for notifications -->
        <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="3000" top>
          {{ snackbar.message }}
          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="snackbar.show = false">ปิด</v-btn>
          </template>
        </v-snackbar>

        <!-- // Start History Dialog -->
        <v-dialog v-model="isShowHistoryDialog" max-width="1300">
          <v-card class="tw-p-4" style="height: auto">
            <div
              class="tw-pb-4 tw-my-4 tw-text-center tw-border-b tw-border-gray tw-mx-4 tw-font-bold"
            >
              ข้อมูลการใช้งานรวม
            </div>
            <div
              class="tw-mx-4 tw-mt-4 tw-max-h-132 tw-flex tw-justify-between"
            >
              <v-select
   :menu-props="{ bottom: true, offsetY: true }"
                v-model="selectedMonth"
                :items="selectedChatGptActivityLog"
                item-value="id"
                item-text="id"
                label="Select Month"
              ></v-select>
            </div>
            <div
              class="tw-mx-4 tw-mt-4 tw-overflow-y-scroll tw-max-h-132 tw-h-146"
            >
              <v-data-table
                class="nowrap"
                hide-default-footer
                :items-per-page="-1"
                :headers="[
                  { text: 'Date', value: 'id' },
                  { text: 'PDF File', value: 'countDetails' },
                  { text: 'Input Tokens', value: 'tokenPrompt' },
                  { text: 'Output Tokens', value: 'tokenCompletion' },
                  { text: 'Total Tokens', value: 'tokenTotal' },
                ]"
                :loading="loading"
                loading-text="Loading... Please wait"
                :items="formatNumbers(selectedDateChatGptActivityLog)"
                item-key="id"
                :single-expand="singleExpand"
                :expanded.sync="expanded"
                show-expand
              >
                <template v-slot:expanded-item="{ item }">
                  <td :colspan="6" class="expanded-item-td">
                    <v-data-table
                      hide-default-footer
                      dense
                      class="elevation-1"
                      :headers="[
                        {
                          text: 'Model Version',
                          value: 'modelVersion',
                          class: 'my-header-style',
                        },
                        {
                          text: 'PDF File',
                          value: 'countDetails',
                          class: 'my-header-style',
                        },
                        {
                          text: 'Input Tokens',
                          value: 'tokenPrompt',
                          class: 'my-header-style',
                        },
                        {
                          text: 'Output Tokens',
                          value: 'tokenCompletion',
                          class: 'my-header-style',
                        },
                        {
                          text: 'Total Tokens',
                          value: 'tokenTotal',
                          class: 'my-header-style',
                        },
                      ]"
                      :items="formatNumbers(item.modelData)"
                      item-key="modelVersion"
                      full-width
                      :item-class="rowClass"
                    ></v-data-table>
                  </td>
                </template>
              </v-data-table>
            </div>
        <!-- selectedChatGptActivityLog {{ selectedChatGptActivityLog }}

        selectedDateChatGptActivityLog {{  selectedDateChatGptActivityLog }} -->

            <div class="tw-mx-4 tw-mt-4 tw-border-t tw-py-4">
              <v-row
                justify="end"
                v-for="model in modelData"
                :key="model.modelVersion"
                class="pa-0 ma-0"
              >
                <v-col cols="12" sm="6" md="4" class="tw-py-0">
                  <v-text-field
                    label="Model"
                    readonly
                    :value="model?.modelVersion"
                    outlined
                    class="text-right"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2" class="tw-py-0">
                  <v-text-field
                    label="Total PDFs"
                    readonly
                    :value="model.countDetails?.toLocaleString()"
                    reverse
                    outlined
                    class="text-right"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2" class="tw-py-0">
                  <v-text-field
                    label="Total Inputs"
                    readonly
                    :value="model.tokenPrompt?.toLocaleString()"
                    reverse
                    outlined
                    class="text-right"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2" class="tw-py-0">
                  <v-text-field
                    label="Total Outputs"
                    readonly
                    :value="model.tokenCompletion?.toLocaleString()"
                    reverse
                    outlined
                    class="text-right"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2" class="tw-py-0">
                  <v-text-field
                    label="Net Tokens"
                    readonly
                    :value="model.tokenTotal?.toLocaleString()"
                    class="text-right"
                    outlined
                    reverse
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>

            <div class="tw-py-4 tw-mx-4 tw-flex tw-mt-2 tw-border-gray">
              <v-btn outlined @click="isShowHistoryDialog = false">ปิด</v-btn>
            </div>
          </v-card>
        </v-dialog>

        <!-- // End of History Dialog -->

        <v-card class="rounded-xl tw-min-h-80">
          <v-card-text>
            <!-- Breadcrumbs -->
            <v-breadcrumbs :items="items">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item :to="item.to" :disabled="item.disabled" :exact="true">
                  {{ item.text }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>

            <!-- API Key Section -->
            <div v-if="isStaff" class="tw-mx-5 tw-font-bold tw-text-lg tw-text-black tw-tracking-wide">
              <div class="tw-flex tw-justify-between tw-items-center">
                <span class="tw-font-bold tw-text-lg tw-text-black tw-tracking-wide"> ตั้งค่าการเชื่อมต่อ API</span>
                <div class="tw-flex tw-gap-4">
                  <v-btn @click="showHistoryDialog" text outlined color="brown" :disabled="isInitializing">
                    <v-icon left>mdi-history</v-icon>
                    ข้อมูลการใช้งานรวม
                  </v-btn>
                </div>
              </div>
            </div>
            <div v-if="isStaff" class="tw-flex tw-mx-8 tw-mt-8">
              <v-row class="tw-flex tw-gap-4">
                <v-col cols="4" class="ma-0 pa-0">
                  <v-text-field
                    v-model="apiKey"
                    outlined
                    dense
                    :type="showKey ? 'text' : 'password'"
                    :append-icon="showKey ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="toggleShowKey"
                    label="API Key"
                    persistent-placeholder
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="ma-0 pa-0">
                  <v-btn color="primary" :loading="isSavingApiKey" :disabled="!apiKey" @click="saveApiKey" class="tw-mr-4">
                    <v-icon left>mdi-content-save</v-icon>
                    <span class="ml-2">บันทึก</span>
                  </v-btn>
                  <v-btn color="info" :loading="isTestingConnection" :disabled="!apiKey" outlined @click="testConnection">
                    <v-icon left>mdi-router-wireless</v-icon>
                    <span class="ml-2">ทดสอบ</span>
                  </v-btn>
                </v-col>
              </v-row>
            </div>

            <!-- Vendor Management Section -->
            <div class="tw-mx-5 tw-mt-8">
              <div class="tw-flex tw-justify-between tw-items-center">
                <span class="tw-font-bold tw-text-lg tw-text-black tw-tracking-wide">ผู้จำหน่าย</span>
                <div class="tw-flex tw-gap-4">
                  <v-btn outlined color="primary" :disabled="isInitializing" @click="addNewVendor">
                    <v-icon left>mdi-plus</v-icon>
                    เพิ่มผู้จำหน่าย
                  </v-btn>
                  <!-- CSV Template Dialog Button -->
                  <v-btn outlined color="secondary" :disabled="isInitializing" @click="openCsvTemplateDialog">
                    <v-icon left>mdi-file-document-outline</v-icon>
                    CSV Template
                  </v-btn>
                  <!-- Bulk Delete Button -->
                  <v-btn outlined color="error" :disabled="selectedVendorIds.length === 0 || isInitializing" @click="confirmBulkDelete">
                    <v-icon left>mdi-delete</v-icon>
                    Bulk Delete
                  </v-btn>
                  <v-btn color="success" :loading="savingChanges" :disabled="!hasUnsavedChanges || savingChanges" @click="saveChanges">
                    <v-icon left>mdi-content-save</v-icon>
                    บันทึกข้อมูลผู้จำหน่าย
                  </v-btn>
                </div>
              </div>
            </div>

            <!-- Vendor Search and Table -->
            <div>
              <div class="tw-flex tw-items-center tw-mt-8 tw-pr-5">
                <v-text-field
                  v-model="vendorSearch"
                  dense
                  outlined
                  class="tw-w-3 tw-mx-5 tw-mt-2"
                  placeholder="ค้นหาผู้จำหน่าย"
                  prepend-inner-icon="mdi-magnify"
                  hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
              </div>
              <div class="tw-mx-5 tw-py-5 tw-overflow-y-auto">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <!-- Header checkbox for "select all" -->
                        <th class="tw-p-2 tw-whitespace-nowrap">
                          <v-checkbox
                            :input-value="allSelected"
                            @click.stop="toggleSelectAll"
                            dense
                            hide-details
                          ></v-checkbox>
                        </th>
                        <th class="tw-p-2 tw-whitespace-nowrap">ลำดับ</th>
                        <th class="tw-p-2 tw-whitespace-nowrap">รหัสบริษัท</th>
                        <th class="tw-p-2 tw-whitespace-nowrap">คำนำหน้า</th>
                        <th class="tw-p-2 tw-whitespace-nowrap">ชื่อบริษัท</th>
                        <th class="tw-p-2 tw-whitespace-nowrap">รหัสสาขา</th>
                        <th class="tw-p-2">ที่อยู่</th>
                        <th class="tw-p-2 tw-whitespace-nowrap">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(vendor, index) in filteredVendors"
                        :key="vendor.venCode"
                        class="tw-tracking-tight tw-leading-3"
                      >
                        <!-- Row checkbox -->
                        <td class="tw-p-2 tw-whitespace-nowrap">
                          <v-checkbox v-model="selectedVendorIds" :value="vendor.vendorId" dense hide-details></v-checkbox>
                        </td>
                        <td class="tw-p-2 tw-whitespace-nowrap">{{ index + 1 }}</td>
                        <td class="tw-p-2 tw-whitespace-nowrap">{{ vendor.venCode }}</td>
                        <td class="tw-p-2 tw-whitespace-nowrap">{{ vendor.venPrefix }}</td>
                        <td class="tw-p-2 tw-whitespace-nowrap">{{ vendor.venName }}</td>
                        <td class="tw-p-2 tw-whitespace-nowrap">{{ vendor.venBranch }} </td>
                        <td class="tw-p-2">{{ vendor.venAddr }}</td>
                        <td class="tw-p-2 tw-whitespace-nowrap">
                          <v-btn icon color="warning" @click="editVendor(vendor)" class="mr-2">
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn icon color="error" @click="confirmVendorDelete(vendor)">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </div>
          </v-card-text>
        </v-card>

        <!-- Vendor Form Dialog -->
        <ap-vendor-form-dialog
          :is-open="showApVendorFormDialog"
          :is-edit-mode="isEditMode"
          :ap-vendor="apVendor"
          :companyID="$route.params.companyId"
          :expenseList="expenseList"
          :paymentList="paymentList"
          :vatList="vatList"
          :whtList="whtList"
          @update:isOpen="showApVendorFormDialog = $event"
          @vendor-updated="updateVendor"
        />

        <!-- Single Vendor Delete Confirmation Dialog -->
        <confirm-delete-vendor-dialog
          :is-open="showVendorDeleteDialog"
          :doc-id-label="vendorToDelete?.venName"
          @confirm="deleteVendor"
          @update:isOpen="showVendorDeleteDialog = $event"
        />

        <!-- Bulk Delete Confirmation Dialog -->
        <v-dialog v-model="showBulkDeleteDialog" persistent max-width="500px">
          <v-card>
            <v-card-title class="headline">ยืนยันการลบ</v-card-title>
            <v-card-text>
              คุณต้องการลบผู้จำหน่ายที่เลือกทั้งหมดหรือไม่?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="showBulkDeleteDialog = false">ยกเลิก</v-btn>
              <v-btn color="red darken-1" text @click="bulkDelete">ยืนยัน</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


        <!-- CSV Template Dialog for Download & Upload -->
        <v-dialog v-model="showCsvTemplateDialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">CSV Template</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <h3 class="tw-mb-2">ดาวน์โหลด CSV Template</h3>
                    <v-btn color="primary" @click="downloadVendorTemplate">
                      <v-icon left>mdi-download</v-icon>
                      ดาวน์โหลด
                    </v-btn>
                  </v-col>
                  <v-col cols="12" class="mt-4">
                    <h3 class="tw-mb-2">อัปโหลด CSV Template</h3>
                    <v-file-input
                      v-model="selectedFile"
                      label="เลือกไฟล์ CSV"
                      accept=".csv"
                      outlined
                      dense
                    ></v-file-input>
                    <v-btn color="primary" :loading="uploadLoading" :disabled="!selectedFile" @click="confirmUpload">
                      <v-icon left>mdi-upload</v-icon>
                      อัปโหลด
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeCsvTemplateDialog">ปิด</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-container>
    </v-main>
  </Admin>
</template>

<script>
import Admin from "../../components/admin/admin-main-template";
import { mapState } from "vuex";
import fc from "@/firebaseConfig";
import ApVendorFormDialog from "@/components/admin/automation/ap-vendor-form-dialog.vue";
import confirmDeleteVendorDialog from "@/components/admin/automation/confirm-delete-vendor-dialog.vue";
import Papa from "papaparse";

export default {
  name: "AI",
  components: { Admin, ApVendorFormDialog, confirmDeleteVendorDialog },
  data: () => ({
    selectedMonth: "",
    expanded: [],
    modelData: [],
    singleExpand: true,
    savingChanges: false,
    snackbar: { show: false, message: "", color: "success" },
    items: [
      { text: "ตั้งค่า", disabled: false, to: { name: "Company.Settings" } },
      { text: "ตั้งค่าผู้จำหน่าย", disabled: true },
    ],
    currentTabIndex: 0,
    showKey: false,
    vendorSearch: "",
    isTestingConnection: false,
    isSavingApiKey: false,
    showDeleteDialog: false,
    hasUnsavedChanges: false,
    apiKey: "",
    isInitializing: true,
    showApVendorFormDialog: false,
    isEditMode: false,
    apVendor: {},
    expenseList: [],
    vatList: [],
    whtList: [],
    paymentList: [],
    companyID: null,
    showVendorDeleteDialog: false,
    vendorToDelete: null,
    // For CSV Template dialog and local vendor editing:
    showCsvTemplateDialog: false,
    selectedFile: null,
    uploadLoading: false,
    editedVendors: [], // Local copy for editing vendors (not yet saved to Firebase)
    vendorsToDelete: [], // Track vendor IDs marked for deletion
    // For bulk delete via checkboxes:
    selectedVendorIds: [],
    showBulkDeleteDialog: false,
    isShowHistoryDialog: false,
  }),
  created() {
    const companyID = this.$route.params.companyId;
    if (companyID) {
      this.$store.dispatch("user/getRoleUser", { companyId: companyID });
    }


    this.getChatGptActivityLog();
    this.selectedMonth = this.getCurrentMonth();

  },
  computed: {
    ...mapState({
      selectedCompany: (state) => state.companies.selectedCompany,
      userCompany: (state) => state.user.userCompany,
      selectedCompanyApVendors: (state) => state.companies.selectedCompanyApVendors,
      loading: (state) => state.companies.loading,
      selectedChatGptActivityLog: (state) =>
        state.companies.selectedChatGptActivityLog,
      selectedDateChatGptActivityLog: (state) =>
        state.companies.selectedDateChatGptActivityLog,
      selectedDateDetailChatGptActivityLog: (state) =>
        state.companies.selectedDateDetailChatGptActivityLog,
    }),
    isStaff() {
      return this.userCompany?.user?.isEngineer || this.userCompany?.isDeveloper;
    },
    isCompanyAdmin() {
      return this.userCompany?.isAdmin;
    },
    filteredVendors() {
      return this.editedVendors.filter((vendor) =>
        vendor.venName?.toLowerCase().includes(this.vendorSearch?.toLowerCase()) ||
        vendor.venCode?.toLowerCase().includes(this.vendorSearch?.toLowerCase()) ||
        vendor.venTaxId?.toLowerCase().includes(this.vendorSearch?.toLowerCase())
      );
    },
    allSelected() {
      const filteredIds = this.filteredVendors.map((v) => v.vendorId);
      return filteredIds.length > 0 && this.selectedVendorIds.length === filteredIds.length;
    }
  },
  watch: {
    selectedCompany: {
      handler(newVal) {
        if (newVal) {
          this.apiKey = newVal.openAiKey || "";
        }
      },
      immediate: true,
    },
    // Update local copy if store vendors change and no unsaved changes exist.
    selectedCompanyApVendors(newVal) {
      if (!this.hasUnsavedChanges) {
        this.editedVendors = JSON.parse(JSON.stringify(newVal));
      }
    },
    selectedMonth(newVal, oldVal) {
      console.log("Selected month changed:", newVal);
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/getDateListChatGptActivityLog", {
        companyId,
        newVal,
      });
      this.modelData = this.findModelData(newVal);
    },
    selectedChatGptActivityLog(newVal, oldVal) {
      console.log("list month", this.selectedChatGptActivityLog.length);
      this.modelData = this.findModelData(this.selectedMonth);
    },
  },
  mounted() {
    this.init();
    this.getMasterDataList();
  },
  methods: {
    fetchDateData() {
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/getDateListChatGptActivityLog", {
        companyId,
        newVal: this.selectedMonth,
      });
    },
    findModelData(month) {
      const selectedData = this.selectedChatGptActivityLog.find(
        (item) => item.id === this.selectedMonth
      );
      return selectedData ? selectedData.modelData : [];
    },
    getCurrentMonth() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const formattedMonth = month < 10 ? `0${month}` : `${month}`;
      return `${year}-${formattedMonth}`;
    },
    getChatGptActivityLog() {
      console.log("start", this.selectedChatGptActivityLog);
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/getChatGptActivityLog", { companyId });
    },
    rowClass() {
      return "row_Class";
    },
    formatNumbers(data) {
      return data.map((item) => ({
        ...item,
        countDetails: item.countDetails.toLocaleString(),
        tokenPrompt: item.tokenPrompt.toLocaleString(),
        tokenCompletion: item.tokenCompletion.toLocaleString(),
        tokenTotal: item.tokenTotal.toLocaleString(),
      }))},
    showHistoryDialog() {
      this.isShowHistoryDialog = true;
    },
    // Preprocess for venSearchString (computed on save, not exported to CSV)
    preprocess(text) {
      return text
        .toLowerCase()
        .replace(/[^\w\s\u0E00-\u0E7F]/g, "")
        .replace(/\s+/g, " ")
        .trim();
    },
    // ── API Key & Connection Methods ──
    toggleShowKey() {
      this.showKey = !this.showKey;
    },
    async testConnection() {
      this.isTestingConnection = true;
      try {
        const response = await fetch("https://api.openai.com/v1/models", {
          headers: { Authorization: `Bearer ${this.apiKey}` },
        });
        if (response.ok) {
          this.notify("success", "การเชื่อมต่อสำเร็จ");
        } else {
          throw new Error("Connection failed");
        }
      } catch (error) {
        this.notify("error", "การเชื่อมต่อล้มเหลว กรุณาตรวจสอบ API Key");
      } finally {
        this.isTestingConnection = false;
      }
    },
    async saveApiKey() {
      this.isSavingApiKey = true;
      try {
        await this.$store.dispatch("companies/updateApiKey", {
          companyId: this.$route.params.companyId,
          apiKey: this.apiKey,
        });
        this.notify("success", "บันทึก API Key สำเร็จ");
      } catch (error) {
        this.notify("error", "เกิดข้อผิดพลาดในการบันทึก API Key");
      } finally {
        this.isSavingApiKey = false;
      }
    },

    // ── Vendor Methods ──
    confirmVendorDelete(vendor) {
      this.vendorToDelete = vendor;
      this.showVendorDeleteDialog = true;
    },
    async deleteVendor() {
      if (this.vendorToDelete) {
        const vendorId = this.vendorToDelete.vendorId;
        // Track the vendor ID for deletion
        this.vendorsToDelete.push(vendorId);
        // Remove from the local editedVendors array
        this.editedVendors = this.editedVendors.filter((vendor) => vendor.vendorId !== vendorId);
        // Also remove from bulk selection if selected
        this.selectedVendorIds = this.selectedVendorIds.filter((id) => id !== vendorId);
        this.hasUnsavedChanges = true;
        this.notify("success", "ลบข้อมูลในหน้าจอเรียบร้อย (ยังไม่บันทึก)");
        this.vendorToDelete = null;
        this.showVendorDeleteDialog = false;
      }
    },
    editVendor(vendor) {
      this.isEditMode = true;
      // Open the vendor form dialog with a deep copy.
      this.apVendor = JSON.parse(JSON.stringify(vendor));
      this.showApVendorFormDialog = true;
    },
    addNewVendor() {
      this.isEditMode = false;
      this.apVendor = {};
      this.showApVendorFormDialog = true;
    },
    // Called when the vendor form dialog emits "vendor-updated"
    updateVendor(updatedVendor) {
      const idx = this.editedVendors.findIndex((v) => v.vendorId === updatedVendor.vendorId);
      if (idx !== -1) {
        this.$set(this.editedVendors, idx, updatedVendor);
      } else {
        this.editedVendors.push(updatedVendor);
      }
      this.hasUnsavedChanges = true;
      this.notify("success", "แก้ไขข้อมูลในหน้าจอแล้ว (ยังไม่บันทึก)");
    },
    async getMasterDataList() {
      const masterRef = await fc.companies.doc(this.companyID).collection("PurchaseInvoiceMaster").get();
      const masterList = masterRef.docs.map((doc) => ({ ...doc.data(), docId: doc.id }));
      this.expenseList = masterList?.find((item) => item.docId === "Expense")?.data || [];
      this.vatList = masterList?.find((item) => item.docId === "Vat")?.data || [];
      this.whtList = masterList?.find((item) => item.docId === "WithholdingTax")?.data || [];
      this.paymentList = masterList?.find((item) => item.docId === "PaymentAccount")?.data || [];
    },
    notify(type, message) {
      this.snackbar = { show: true, message, color: type };
    },
    async init() {
      this.isInitializing = true;
      this.companyID = this.$route.params.companyId;
      if (this.companyID) {
        try {
          await Promise.all([
            this.$store.dispatch("user/getRoleUser", { companyId: this.companyID }),
            this.$store.dispatch("companies/fetchApVendors", { companyId: this.companyID }),
          ]);
          // Deep copy vendors from store to local editedVendors.
          this.editedVendors = JSON.parse(JSON.stringify(this.selectedCompanyApVendors));
        } catch (error) {
          console.error("Error initializing:", error);
          this.notify("error", "เกิดข้อผิดพลาดในการดึงข้อมูล");
        }
      }
      this.isInitializing = false;
    },
    async saveChanges() {
      // When the user clicks "บันทึกข้อมูลผู้จำหน่าย", commit local vendor changes and  selections to Firebase.
      this.savingChanges = true;
      try {
        const companyId = this.$route.params.companyId;
        const vendorCollectionRef = fc.companies.doc(companyId).collection("PurchaseInvoiceVendors");
        const batch = fc.db.batch();

        // Delete vendors that were removed
        this.vendorsToDelete.forEach((vendorId) => {
          const docRef = vendorCollectionRef.doc(vendorId);
          batch.delete(docRef);
        });

        // Update or add vendors from the local editedVendors array
        this.editedVendors.forEach((vendor) => {
          vendor.venSearchString = this.preprocess(
            `${vendor.venName} ${vendor.venBranch === "00000" ? vendor.venBranch : ""} ${vendor.venTaxId}`
          );
          let vid = vendor.vendorId || vendorCollectionRef.doc().id;
          vendor.vendorId = vid;
          const docRef = vendorCollectionRef.doc(vid);
          batch.set(docRef, vendor, { merge: true });
        });


        await batch.commit();
        // Clear the deletion tracker after successful commit
        this.vendorsToDelete = [];
        this.hasUnsavedChanges = false;
        this.notify("success", "บันทึกข้อมูลผู้จำหน่ายสำเร็จ");
        await this.$store.dispatch("companies/fetchApVendors", { companyId });
      } catch (error) {
        console.error("Error saving vendors", error);
        this.notify("error", "เกิดข้อผิดพลาดในการบันทึกข้อมูลผู้จำหน่าย");
      } finally {
        this.savingChanges = false;
      }
    },
    // ── Bulk Delete Methods ──
    toggleSelectAll() {
      const filteredIds = this.filteredVendors.map((v) => v.vendorId);
      if (this.selectedVendorIds.length === filteredIds.length) {
        this.selectedVendorIds = [];
      } else {
        this.selectedVendorIds = filteredIds;
      }
    },
    confirmBulkDelete() {
      this.showBulkDeleteDialog = true;
    },
    bulkDelete() {
      // Add all selected vendor IDs to the deletion tracker
      this.selectedVendorIds.forEach((id) => {
        if (!this.vendorsToDelete.includes(id)) {
          this.vendorsToDelete.push(id);
        }
      });
      // Remove the selected vendors from the local list
      this.editedVendors = this.editedVendors.filter(
        (vendor) => !this.selectedVendorIds.includes(vendor.vendorId)
      );
      // Clear bulk selection and close the dialog
      this.selectedVendorIds = [];
      this.showBulkDeleteDialog = false;
      this.hasUnsavedChanges = true;
      this.notify("success", "ลบผู้จำหน่ายที่เลือกในหน้าจอเรียบร้อย (ยังไม่บันทึก)");
    },

    // ── CSV Template Download & Upload (using PapaParse) ──
    flattenVendor(vendor) {
      return {
        vendorId: vendor.vendorId || "",
        venCode: vendor.venCode || "",
        venPrefix: vendor.venPrefix || "",
        venName: vendor.venName || "",
        venBranch: vendor.venBranch || "",
        venAddr: vendor.venAddr || "",
        venTaxId: vendor.venTaxId || "",
        venZipCode: vendor.venZipCode || "",
        payCode: vendor.payCode || "",
        payData_payCode: vendor.payData?.payCode || "",
        payData_payName: vendor.payData?.payName || "",
        payData_tranType: vendor.payData?.tranType || "",
        isRejected: vendor.isRejected === 'TRUE' ? true : false,
        defaultAcctP00_expCode: vendor.defaultAcctP00?.expCode || "",
        defaultAcctP00_expData_expName: vendor.defaultAcctP00?.expData?.expName || "",
        defaultAcctP00_expData_acctCode: vendor.defaultAcctP00?.expData?.acctCode || "",
        defaultAcctP00_expData_acctName: vendor.defaultAcctP00?.expData?.acctName || "",
        defaultAcctP00_expData_tranType: vendor.defaultAcctP00?.expData?.tranType || "",
        defaultAcctP00_vatCode: vendor.defaultAcctP00?.vatCode || "",
        defaultAcctP00_vatData_vatName: vendor.defaultAcctP00?.vatData?.vatName || "",
        defaultAcctP00_vatData_vatType: vendor.defaultAcctP00?.vatData?.vatType || "",
        defaultAcctP00_vatData_acctCode: vendor.defaultAcctP00?.vatData?.acctCode || "",
        defaultAcctP00_vatData_acctName: vendor.defaultAcctP00?.vatData?.acctName || "",
        defaultAcctP00_vatData_tranType: vendor.defaultAcctP00?.vatData?.tranType || "",
        defaultAcctP00_whtCode: vendor.defaultAcctP00?.whtCode || "",
        defaultAcctP00_whtData_whtName: vendor.defaultAcctP00?.whtData?.whtName || "",
        defaultAcctP00_whtData_whtRate: vendor.defaultAcctP00?.whtData?.whtRate || "",
        defaultAcctP00_whtData_acctCode: vendor.defaultAcctP00?.whtData?.acctCode || "",
        defaultAcctP00_whtData_acctName: vendor.defaultAcctP00?.whtData?.acctName || "",
        defaultAcctP00_whtData_tranType: vendor.defaultAcctP00?.whtData?.tranType || "",
        defaultAcctP07_expCode: vendor.defaultAcctP07?.expCode || "",
        defaultAcctP07_expData_expName: vendor.defaultAcctP07?.expData?.expName || "",
        defaultAcctP07_expData_acctCode: vendor.defaultAcctP07?.expData?.acctCode || "",
        defaultAcctP07_expData_acctName: vendor.defaultAcctP07?.expData?.acctName || "",
        defaultAcctP07_expData_tranType: vendor.defaultAcctP07?.expData?.tranType || "",
        defaultAcctP07_vatCode: vendor.defaultAcctP07?.vatCode || "",
        defaultAcctP07_vatData_vatName: vendor.defaultAcctP07?.vatData?.vatName || "",
        defaultAcctP07_vatData_vatType: vendor.defaultAcctP07?.vatData?.vatType || "",
        defaultAcctP07_vatData_acctCode: vendor.defaultAcctP07?.vatData?.acctCode || "",
        defaultAcctP07_vatData_acctName: vendor.defaultAcctP07?.vatData?.acctName || "",
        defaultAcctP07_vatData_tranType: vendor.defaultAcctP07?.vatData?.tranType || "",
        defaultAcctP07_whtCode: vendor.defaultAcctP07?.whtCode || "",
        defaultAcctP07_whtData_whtName: vendor.defaultAcctP07?.whtData?.whtName || "",
        defaultAcctP07_whtData_whtRate: vendor.defaultAcctP07?.whtData?.whtRate || "",
        defaultAcctP07_whtData_acctCode: vendor.defaultAcctP07?.whtData?.acctCode || "",
        defaultAcctP07_whtData_acctName: vendor.defaultAcctP07?.whtData?.acctName || "",
        defaultAcctP07_whtData_tranType: vendor.defaultAcctP07?.whtData?.tranType || "",
      };
    },
    unflattenVendor(row) {
      const vendor = {
        vendorId: row.vendorId,
        venCode: row.venCode,
        venPrefix: row.venPrefix,
        venName: row.venName,
        venBranch: row.venBranch,
        venAddr: row.venAddr,
        venTaxId: row.venTaxId,
        venZipCode: row.venZipCode,
        payCode: row.payCode,
        payData: {
          payCode: row.payData_payCode,
          payName: row.payData_payName,
          tranType: row.payData_tranType,
        },
        isRejected: row.isRejected === 'TRUE' ? true : false,
        defaultAcctP00: {
          expCode: row.defaultAcctP00_expCode,
          expData: {
            expName: row.defaultAcctP00_expData_expName,
            acctCode: row.defaultAcctP00_expData_acctCode,
            acctName: row.defaultAcctP00_expData_acctName,
            tranType: row.defaultAcctP00_expData_tranType,
          },
          vatCode: row.defaultAcctP00_vatCode,
          vatData: {
            vatName: row.defaultAcctP00_vatData_vatName,
            vatType: row.defaultAcctP00_vatData_vatType,
            acctCode: row.defaultAcctP00_vatData_acctCode,
            acctName: row.defaultAcctP00_vatData_acctName,
            tranType: row.defaultAcctP00_vatData_tranType,
          },
          whtCode: row.defaultAcctP00_whtCode,
          whtData: {
            whtName: row.defaultAcctP00_whtData_whtName,
            whtRate: row.defaultAcctP00_whtData_whtRate,
            acctCode: row.defaultAcctP00_whtData_acctCode,
            acctName: row.defaultAcctP00_whtData_acctName,
            tranType: row.defaultAcctP00_whtData_tranType,
          },
        },
        defaultAcctP07: {
          expCode: row.defaultAcctP07_expCode,
          expData: {
            expName: row.defaultAcctP07_expData_expName,
            acctCode: row.defaultAcctP07_expData_acctCode,
            acctName: row.defaultAcctP07_expData_acctName,
            tranType: row.defaultAcctP07_expData_tranType,
          },
          vatCode: row.defaultAcctP07_vatCode,
          vatData: {
            vatName: row.defaultAcctP07_vatData_vatName,
            vatType: row.defaultAcctP07_vatData_vatType,
            acctCode: row.defaultAcctP07_vatData_acctCode,
            acctName: row.defaultAcctP07_vatData_acctName,
            tranType: row.defaultAcctP07_vatData_tranType,
          },
          whtCode: row.defaultAcctP07_whtCode,
          whtData: {
            whtName: row.defaultAcctP07_whtData_whtName,
            whtRate: row.defaultAcctP07_whtData_whtRate,
            acctCode: row.defaultAcctP07_whtData_acctCode,
            acctName: row.defaultAcctP07_whtData_acctName,
            tranType: row.defaultAcctP07_whtData_tranType,
          },
        },
      };

      return vendor;
    },
    openCsvTemplateDialog() {
      this.selectedFile = null;
      this.showCsvTemplateDialog = true;
    },
    closeCsvTemplateDialog() {
      this.showCsvTemplateDialog = false;
      this.selectedFile = null;
    },
    downloadVendorTemplate() {
      const headers = Object.keys(this.flattenVendor({}));
      const flatData = this.editedVendors.map((vendor) => this.flattenVendor(vendor));
      const csvContent = Papa.unparse(flatData, { fields: headers });
      const bom = "\ufeff";
      const blob = new Blob([bom + csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "vendor_config_template.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    confirmUpload() {
      if (!this.selectedFile) return;
      this.uploadLoading = true;
      Papa.parse(this.selectedFile, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          const data = results.data;
          if (!data.length) {
            this.notify("error", "ไม่มีข้อมูลผู้จำหน่ายที่สามารถอัปโหลดได้");
            this.uploadLoading = false;
            return;
          }
          const csvVendors = data.map((row) => this.unflattenVendor(row));
          csvVendors.forEach((csvVendor) => {
            const index = this.editedVendors.findIndex((vendor) => vendor.venCode === csvVendor.venCode);
            if (index !== -1) {
              this.$set(this.editedVendors, index, { ...this.editedVendors[index], ...csvVendor });
            } else {
              this.editedVendors.push(csvVendor);
            }
          });
          this.hasUnsavedChanges = true;
          this.notify("success", "อัปโหลด CSV เสร็จสิ้น (ยังไม่บันทึก)");
          this.closeCsvTemplateDialog();
          this.uploadLoading = false;
        },
        error: (err) => {
          console.error("Error parsing CSV", err);
          this.notify("error", "เกิดข้อผิดพลาดในการอ่านไฟล์ CSV");
          this.uploadLoading = false;
        },
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.v-tab {
  text-transform: none;
  padding-right: 8px !important;
  .v-btn {
    margin-left: 8px;
  }
}

.row-wrapper {
  padding-left: 20px;
}

.nowrap th,
td {
  white-space: nowrap;
}

.expanded-item-td {
  padding: 0;
}

.v-data-table
  > .v-data-table__wrapper
  tbody
  tr.v-data-table__expanded__content {
  box-shadow: 0 0 0 0 !important;
}

.my-header-style {
  background: rgba(59, 130, 246, 0.5);
}

.row_Class {
  background-color: rgba(0, 0, 0, 0.12);
}

.vendor-avatar {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.img-show {
  width: 6rem;
  height: 6rem;
  object-fit: contain;
}
</style>
